"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Uploading = exports.ProgressBar = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importStar(require("react"));
var styles_1 = require("../../../../styles");
var shared_1 = require("../shared");
var Button_1 = require("./Button");
var Wrapper_1 = require("./Wrapper");
var models_1 = require("./models");
var MAX_PROGRESS = 80;
var StyledBarWrapper = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 8px;\n  border-radius: 4px;\n  background-color: ", ";\n  position: relative;\n"], ["\n  height: 8px;\n  border-radius: 4px;\n  background-color: ", ";\n  position: relative;\n"])), styles_1.COLOR.progressBar.background);
var StyledBar = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  transition: width 0.2s;\n  position: absolute;\n  height: 100%;\n  left: 0;\n  top: 0;\n  border-radius: 4px;\n  background-color: ", ";\n"], ["\n  transition: width 0.2s;\n  position: absolute;\n  height: 100%;\n  left: 0;\n  top: 0;\n  border-radius: 4px;\n  background-color: ", ";\n"])), styles_1.COLOR.progressBar.progress);
var PROGRESS_MIN_DURATION_SEED = 300;
var PROGRESS_UPLOADING_FILE_SIZE_DENOMINATOR = 2000;
var defaultProgressDurationSeed = PROGRESS_MIN_DURATION_SEED * PROGRESS_UPLOADING_FILE_SIZE_DENOMINATOR;
var ProgressBar = function (_a) {
    var status = _a.status, _b = _a.uploadingFileSize, uploadingFileSize = _b === void 0 ? defaultProgressDurationSeed : _b;
    var _c = react_1.useState(0), progress = _c[0], setProgress = _c[1];
    var uploading = shared_1.FILE_UPLOAD_INPUT_STATUS.uploading, uploadComplete = shared_1.FILE_UPLOAD_INPUT_STATUS.uploadComplete;
    var timer = react_1.useRef(null);
    var value = status === uploadComplete ? 100 : progress;
    react_1.useEffect(function () {
        if (status === uploading && progress < MAX_PROGRESS) {
            var durationSeed = Math.max(uploadingFileSize / PROGRESS_UPLOADING_FILE_SIZE_DENOMINATOR, PROGRESS_MIN_DURATION_SEED);
            var duration = Math.floor(Math.random() * durationSeed);
            timer.current = setTimeout(function () {
                setProgress(function (prev) { return prev + 1; });
            }, duration);
        }
        return function () {
            if (timer.current != null) {
                clearTimeout(timer.current);
            }
        };
    }, [uploadingFileSize, progress, status, uploading]);
    return (react_1.default.createElement(StyledBarWrapper, null,
        react_1.default.createElement(StyledBar, { style: { width: value + "%" } })));
};
exports.ProgressBar = ProgressBar;
var doNothing = function () {
    // nothing to do
};
var ButtonBlock = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-top: 8px;\n"], ["\n  margin-top: 8px;\n"])));
var Uploading = function (_a) {
    var propertyId = _a.propertyId, status = _a.status, uploadingFileSize = _a.uploadingFileSize, accept = _a.accept;
    return (react_1.default.createElement(Wrapper_1.Wrapper, { padding: '8px 16px', disabled: false, error: false },
        react_1.default.createElement("div", null,
            react_1.default.createElement(exports.ProgressBar, { status: status, uploadingFileSize: uploadingFileSize })),
        react_1.default.createElement(ButtonBlock, null,
            react_1.default.createElement(Button_1.FileUploadButton, { disabled: true, error: false, propertyId: propertyId, onFileSelect: doNothing, label: models_1.BUTTON_LABEL_READY, accept: accept }))));
};
exports.Uploading = Uploading;
var templateObject_1, templateObject_2, templateObject_3;
